import { ApolloClient, ApolloLink, split, InMemoryCache } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
//import { getMainDefinition } from '@apollo/client/utilities';
import { onError } from '@apollo/client/link/error';
// import { WebSocketLink } from '@apollo/client/link/ws';

import { API_ROOT, getAuthRedirectUrl, getApiAuthOptions } from './environment';

const httpLink = new HttpLink({
  uri: API_ROOT,
  ...getApiAuthOptions()
});

const errorLink = onError(({ networkError }) => {
  // if API call fails due to authentication error, redirect to login page
  if (networkError && networkError.statusCode === 401) {
    window.location = getAuthRedirectUrl();
  }
});

//
// Temporary removal of websockets. To enable subscriptions, uncomment below lines an replace line #49
// link: ApolloLink.from([errorLink, httpLink])
// with:
// link: ApolloLink.from([errorLink, splitLink])
//
// const wsLink = new WebSocketLink({
//   uri: getSubscriptionUrl(),
//   options: {
//     reconnect: true
//   }
// });

// const splitLink = split(
//   // split based on operation type
//   ({ query }) => {
//     const definition = getMainDefinition(query);
//     return (
//       definition.kind === 'OperationDefinition' &&
//       definition.operation === 'subscription'
//     );
//   },
//   wsLink,
//   httpLink
// );

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorLink, httpLink])
});

apolloClient.defaultOptions = {
  query: {
    errorPolicy: 'all'
  },
  mutate: {
    errorPolicy: 'all'
  }
};

export default apolloClient;
